import { useEffect, useRef, useState } from "react";

export default function CustomDropdownButton({ title, children, drop = "end", className = "" }) {
  const [open, setOpen] = useState(false);
  const leaveTimeoutRef = useRef(null);
  const menuRef = useRef(null);
  const [positionAbove, setPositionAbove] = useState(false);

  const onMouseEnter = () => {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
    setOpen(true);
  };

  const onMouseLeave = () => {
    leaveTimeoutRef.current = setTimeout(() => {
      setOpen(false);
      setPositionAbove(false)
    }, 50);
  };

  // Detect overflow on open
  useEffect(() => {
    if (open && menuRef.current) {
      const rect = menuRef.current.getBoundingClientRect();
      const bottomOverflow = rect.bottom > window.innerHeight;
      setPositionAbove(bottomOverflow);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
    };
  }, []);

  const submenuStyle = {
    position: "absolute",
    [drop === "start" ? "right" : "left"]: "100%",
    top: positionAbove ? "auto" : "0",
    bottom: positionAbove ? "0" : "auto",
    zIndex: 999,
    minWidth: "160px"
  };

  const containerClass = `custom-dropdown-button p-0 dropdown-menu drop${drop} ${open ? "show" : ""} position-relative d-inline-block ${className}`;

  return (
    <div
      className={containerClass}
      onPointerEnter={onMouseEnter}
      onPointerDown={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ userSelect: "none", border: 0 }}
    >
      <button type="button" className="btn btn-primary dropdown-toggle">
        {title}
      </button>

      {open && (
        <div ref={menuRef} className="custom-dropdown-menu dropdown-menu show" style={submenuStyle}>
          {children}
        </div>
      )}
    </div>
  );
}